export const Indetity = {
  User: {
    UserAdded: 'USER_ADDED',
    UserDeleted: 'USER_DELETED',
    UserUpdated: 'USER_UPDATED',
  },
};
